import {http, onSuccess, onFail} from './http';

export const getConnection = (params) =>
    http.get('/api/player/client/connection', {params})
        .then(onSuccess, onFail);

export const statisticWatchStart = (streamId, data) =>
    http.post(`/api/player/event/stream/${streamId}/streamWatch`, data)
        .then(onSuccess, onFail);

export const statisticWatchStop = (watchId, data) =>
    http.put(`/api/player/event/stream/streamWatch/${watchId}`, data)
        .then(onSuccess, onFail);

export const statisticEpisodeWatch = (id) =>
    http.post(`/api/player/event/stream/episode/${id}/watch`)
        .then(onSuccess, onFail);
